const ENV = process.env['APP_ENV'] || 'local';

let config = {
  local: {
    hostURL: 'http://localhost:3000'
  },
  production: {
    hostURL: 'http://80apptester.80legs.com'
  }, 
  qa: {
    hostURL: 'http://80apptester-qa.80legs.com'
  }
};

export default config[ENV];


// WEBPACK FOOTER //
// ./src/config.js